import qs from 'qs';
import {
    finalizeResponse,
    handleError,
    axiosConfigs,
    checkResponseLoggedOut
} from 'tradera/utils/api';
import { touchWebClient } from 'tradera/utils/http';

export const postFavoriteSeller = async (sellerId, isAlreadySaved) => {
    const payload = isAlreadySaved
        ? qs.stringify({ ids: sellerId })
        : qs.stringify({ sellerId: sellerId });
    const action = isAlreadySaved ? 'remove' : 'add';
    const url = `/my/favourite-sellers/${action}`;
    return touchWebClient
        .post(url, payload, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            ...axiosConfigs
        })
        .then(checkResponseLoggedOut())
        .then(finalizeResponse())
        .catch(handleError());
};
